import { action, EmptyAction, PayloadAction } from 'typesafe-actions';
import { userInputActions, UserInputState } from './userInput.types';

export const saveUserInput = (data: UserInputState): PayloadAction<string, UserInputState> =>
	action(userInputActions.saveUserInput, data);

export const clearUserInput = (): EmptyAction<string> => action(userInputActions.clearUserInput);
